import React, { useState, useEffect } from 'react'

import './RotatingContent.css'

interface RotatingContentProps {
  children: React.ReactNode
  interval?: number
  className?: string
}

export default function RotatingContent({
  children,
  interval = 6000,
  className = ''
}: RotatingContentProps) {
  const [currentIndex, setCurrentIndex] = useState(0)
  const childrenArray = React.Children.toArray(children)
  const totalChildren = childrenArray.length

  useEffect(() => {
    if (totalChildren <= 1) return

    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % totalChildren)
    }, interval)

    return () => clearInterval(timer)
  }, [interval, totalChildren])

  return (
    <div className={`rotating-content ${className}`}>
      {childrenArray.map((child, index) => (
        <div
          key={index}
          className={`rotating-item ${index === currentIndex ? 'active' : 'inactive'}`}
        >
          {child}
        </div>
      ))}
    </div>
  )
}
